import script from "./generalKYCView2.vue?vue&type=script&setup=true&lang=js"
export * from "./generalKYCView2.vue?vue&type=script&setup=true&lang=js"

import "./generalKYCView2.vue?vue&type=style&index=0&id=63ac97a4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ac97a4"]])

export default __exports__